import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Container } from 'react-bootstrap';
import { USER_GROUP_DEFAULT, getUserGroup } from '../../../User/UserGroupActions';
import LazyLoader from '../../../../components/Content/LazyLoader';
import CmsPanel from '../../../Cms/components/content/CmsPanel';

function ProductShippingInformation({ userGroup, mode = null }) {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if(mounted && (!userGroup || userGroup.identifier === USER_GROUP_DEFAULT /* || process.env.NODE_ENV === 'development' */)) {
		return (
			<div className={classNames('pt-0', 'pt-3', mode !== 'compact' && 'pb-3', 'px-0', 'px-lg-3')}>
				<CmsPanel slug="shipping-information" mode={mode} />
			</div>
		);
	}
}

ProductShippingInformation.propTypes = {
	userGroup: PropTypes.object.isRequired,
	mode: PropTypes.string,
};

function mapStateToProps(store, props) {
    return {
        userGroup: getUserGroup(store),
    };
}

export default connect(mapStateToProps)(ProductShippingInformation);
